import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { ProductsSection } from '../products-section';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { NEW_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import { productNavigation } from 'src/areas/product/actions/product';
import type { Product } from 'src/types';

type Props = {
  newReleases?: Product[];
  negativeMargin?: boolean;
};

const NewProductReleases: React.FC<Props> = props => {
  const { newReleases: newProducts = [], negativeMargin } = props;
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  if (!newProducts || !newProducts.length) {
    return null;
  }

  const newProductsItems = filterCategories(newProducts);

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    dispatch(productNavigation(NEW_PRODUCT_CLICK, data.index + 1));
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={newProductsItems}
      title={t('landing', 'personalized-releases.title')}
      shouldLazyLoadImages
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      negativeMargin={negativeMargin}
    />
  );
};

export default NewProductReleases;
